import Box from '@mui/material/Box/Box';
import Typography from '@mui/material/Typography/Typography';
import Link from '@mui/material/Link/Link';
import CardActionArea from '@mui/material/CardActionArea';
import Card from '@mui/material/Card';

import { LinkIcon } from 'icons';

import type { UsefulLink } from '../types';

export const UsefulLinkTile = ({ title, description, link }: UsefulLink) => (
  <Card
    sx={{
      mb: 4,
    }}
  >
    <CardActionArea
      href={link}
      target="_blank"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderRadius: '10px',
        padding: '24px',
        gap: 4,
      }}
    >
      <Box>
        <Typography variant="h4" fontWeight={600} color="primary.dark" mb={2}>
          {title}
        </Typography>
        <Typography variant="textMedium" color="grey.400">
          {description}
        </Typography>
      </Box>

      <Link
        component={Box}
        href={link}
        target="_blank"
        sx={{
          display: 'grid',
          alignItems: 'center',
          backgroundColor: 'primary.light',
          padding: '8px',
          borderRadius: '50%',
        }}
      >
        <LinkIcon />
      </Link>
    </CardActionArea>
  </Card>
);
